// extracted by mini-css-extract-plugin
export default {"body":"main_body__93010","overflow":"main_overflow__u8Ucp","icon":"main_icon__vYyAI","link":"main_link__NzmK8"};